// 首次创建子账号申请

import ModalComponent from "@/components/ui/modal";
import { Text, Flex, Image, Textarea } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import { BXButton } from "@/styles";
import { useState } from "react";
import { getSubAccountCreatePermissionApi } from "@/api/subAccount";

const ApplyModal = ({ show, onCancel, onOK }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();
  const [inputValue, setInputValue] = useState("");

  const getSubAccountCreatePermission = async () => {
    if (!inputValue) return;
    const res = await getSubAccountCreatePermissionApi({ reason: inputValue });
    if (res.code === 0) {
      const { status } = res.data;
      onOK && onOK(status);
    }
  };

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "378px" : "calc(100% - 30px)" }}
    >
      <Flex
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={["30px 30px"]}
      >
        <Flex justifyContent={"space-between"} w={"100%"}>
          <Text fontSize={"16px"} fontWeight={500}>
            {t("IldgeERuYKVOefpR")}
          </Text>
          <Image
            src={"../../wwwsite/images/bill/close.svg"}
            cursor={"pointer"}
            onClick={() => {
              setInputValue("");
              onCancel && onCancel();
            }}
          />
        </Flex>
        <Text mt={"20px"} fontWeight={400} fontSize={"14px"}>
          {t("XaQWqbeAdXIkLCiakX")}
        </Text>
        <Textarea
          type="textarea"
          rows={3}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          mt={"20px"}
          maxLength={300}
          placeholder={t("WHFSIZvkPFlAiUsTW")}
          _placeholder={{ fontSize: "14px" }}
        ></Textarea>
        <Flex justifyContent={"center"} mt={"30px"}>
          <BXButton
            className={!inputValue ? "disabled" : ""}
            w={["100%", "200px"]}
            onClick={() => {
              getSubAccountCreatePermission();
            }}
          >
            {t("QFbYEdxUgXzRwcPFQDis")}
          </BXButton>
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default ApplyModal;
